import img1 from "../../Assets/Images/Gallery/installed-gallery-01.png";
import img2 from "../../Assets/Images/Gallery/installed-gallery-02.png";
// import img3 from "../../Assets/Images/Gallery/installed-gallery-03.png";
import img4 from "../../Assets/Images/Gallery/installed-gallery-04.png";
import img5 from "../../Assets/Images/Gallery/installed-gallery-05.png";
import img6 from "../../Assets/Images/Gallery/installed-gallery-06.png";
import img7 from "../../Assets/Images/Gallery/installed-gallery-07.png";
import img8 from "../../Assets/Images/Gallery/installed-gallery-08.png";
import img9 from "../../Assets/Images/Gallery/installed-gallery-09.png";
import img10 from "../../Assets/Images/Gallery/installed-gallery-10.png";
import img11 from "../../Assets/Images/Gallery/installed-gallery-11.png";
import img12 from "../../Assets/Images/Gallery/installed-gallery-12.png";

export const GalleryData = (t: any) => [
  {
    status: t("status.completed"),
    quantity: t("quantity.one_ilwall"),
    location: t("projects.posco_lobby"),
    time: "2021.12.08",
    img: img1,
    contentHover: t("details.sangmoon_album"),
    router: "/DDP"
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.twelve_ilwall"),
    location: t("projects.posco_lobby"),
    time: "2021.10.06",
    img: img2,
    contentHover: t("details.posco_lobby"),
    router: "/Infomation"
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.six_ilwall"),
    location: t("projects.ddp_media"),
    time: "2021.10.06",
    img: img8,
    contentHover: t("details.sports_monster"),
    router: "/Media"
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.three_ilwall"),
    location: t("projects.jurassic_museum"),
    time: "2017.08.24",
    img: img4,
    contentHover: t("details.jurassic_museum"),
    router: "/Jurassic"
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.four_ilwall"),
    location: t("projects.gangnam_galleria"),
    time: "2017.08.24",
    img: img5,
    contentHover: t("details.gangnam_galleria"),
    router: "/Gangnaum"
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.one_ilwall"),
    location: t("projects.lg_prism"),
    time: "2017.06.22",
    img: img6,
    contentHover: t("details.lg_prism"),
    router: "/LG"
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.one_ilwall"),
    location: t("projects.samsung_sds"),
    time: "2017.08.24",
    img: img7,
    contentHover: t("details.samsung_sds"),
    router: "SAMSUNG"
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.six_ilwall"),
    location: t("projects.wooributeo"),
    time: "2017.08.24",
    img: img8,
    contentHover: t("details.sports_monster"),
    router: "/Infomation"
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.seven_ilwall"),
    location: t("projects.zhengzhou_library"),
    time: "2017.08.24",
    img: img9,
    contentHover: t("details.zhengzhou_library"),
    router: "/Zhengzhou"
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.four_ilwall"),
    location: t("projects.taean_skypark"),
    time: "2017.08.24",
    img: img10,
    contentHover: t("details.taean_skypark"),
    router: "/Zhengzhou"
  },
  {
    status: t("status.installing"),
    quantity: t("quantity.three_ilwall"),
    location: t("projects.samsung_sds"),
    time: "2017.08.24",
    img: img11,
    contentHover: t("details.samsung_cinema"),
    router: "/Sangam"
  },
  {
    status: t("status.completed"),
    quantity: t("quantity.one_ilwall"),
    location: t("projects.ddp_info"),
    time: "2017.08.24",
    img: img12,
    contentHover: t("details.ddp_info"),
    router: "/Infomation"
  }
];
